import React, { useMemo, useState } from 'react';
import DHeader from '../../pieces/DHeader';
import DText from '../../pieces/DText';
import DCode from '../../pieces/DCode';

export default function WorkflowEdges() {

    return (
        <div>
            <DHeader>Edges- Flow of Control</DHeader>
       
            <DText>
            Edges are the way to define the flow of Control in a workflow. Once Nodes are added to the workflow, you need to explicitly define Edges between the different actions in the Nodes.
            This tells the orchestrator in what order to call the Actions.
             

            </DText>

            <DText>
            The Actions are specified in the Edges using the format : Node name followed by ‘|’ followed by the Action name. 
            The first action to be executed is the one connected to the START Edge as shown below.
            </DText>
            

            <DCode>
                {`simple_flow.add_edge("START", "Model0|model0")`}
            </DCode>

            <DText>
            The first Action is connected to the next one as shown below. 
            The Edge goes from the Action ‘model0’ of Node ‘Model0’ to the Action ‘model1’ of Node ‘Model1’.
            </DText>

            <DCode>
                {`simple_flow.add_edge("Model0|model0", "Model1|model1")`}
            </DCode>


            <DText>
            The last Action, must be connected to the END Edge to indicate the end of the workflow.
            </DText>

            <DCode>
                {`simple_flow.add_edge("Model1|model1", "END")`}
            </DCode>

          
            
            {/* <DCode>
                {`python QuickStart.py`}
            </DCode> */}
       
        </div>
    )
}